import { WebPortalService } from '../resource'

const PilotNumberModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    SET_DATA (state, data) {
      state.data = data
    }
  },
  actions: {
    
    createData ({ commit, state }, data) {
        return WebPortalService.PilotNumberCreate(data)
    },
    updateData ({ commit, state }, data) {
        return WebPortalService.PilotNumberCreate(data)
    },
    deleteData ({ commit, state }, data) {
        return WebPortalService.PilotNumberDelete(data)
    },
    bgAdmin ({ commit, state }, data) {
        return WebPortalService.BGAdmin(data)
    },
    syncPackage({ commit, state }, data) {
        return WebPortalService.SyncPackage(data)
    },
    async listData ({ commit, state }) {
      try{
        const data = await WebPortalService.PilotNumberList()
        if (data.data.Data == null) 
        {
          commit('SET_DATA', [])
        }
        else 
        {
          commit('SET_DATA', data.data.Data)
        }
      }
      catch(err)
      {
        commit('SET_DATA', [])
      }
    },
    async listDataByEnterprise ({ commit, state },param) {
      try{
        const data = await WebPortalService.PilotNumberListByEnterprise(param)
        if (data.data.Data == null) 
        {
          commit('SET_DATA', [])
        }
        else 
        {
          commit('SET_DATA', data.data.Data)
        }
      }
      catch(err)
      {
        commit('SET_DATA', [])
      }
    }
  },
  getters: {
    getData (state) {
      return state.data
    },
    getRealNumber: (state) => (entId) => {
        let result =  state.data.filter((m)=>{
          return m.EnterpriseID ==  entId && m.Type == 4
        });
        return result
    },
  }
}

export default PilotNumberModule